import { render, staticRenderFns } from "./NotificationSidePanel.vue?vue&type=template&id=c5c05072&scoped=true"
import script from "./NotificationSidePanel.vue?vue&type=script&lang=js"
export * from "./NotificationSidePanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationSidePanel.vue?vue&type=style&index=0&id=c5c05072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c05072",
  null
  
)

export default component.exports